import { render, staticRenderFns } from "./welcome-page.vue?vue&type=template&id=433666ec&scoped=true"
import script from "./welcome-page.vue?vue&type=script&lang=js"
export * from "./welcome-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433666ec",
  null
  
)

export default component.exports